var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("sub-tab", { attrs: { currentTab: _vm.tab, subTab: _vm.subTab } }),
      _vm._v(" "),
      _vm.tab === "top"
        ? _c("top", { attrs: { currentTab: _vm.tab } })
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "inventory" && _vm.subTab === "inventory-inquiry"
        ? _c("inventory-inquiry")
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "inventory" && _vm.subTab === "inventory-end-of-month"
        ? _c("inventory-end-of-month")
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "delivery"
        ? _c("delivery-status-inquiry", {
            attrs: { currentTab: _vm.tab, subTab: _vm.subTab }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "expense-details" && _vm.subTab === "shipment-record"
        ? _c("shipping-cost")
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "expense-details" && _vm.subTab === "storage-fees"
        ? _c("other-cost")
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "settings" && _vm.subTab === "price-diff"
        ? _c("setting-across-price-diff")
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "shipping" && _vm.subTab === "shipping-status-inquiry"
        ? _c("shipping-list")
        : _vm._e(),
      _vm._v(" "),
      _vm.tab === "shipping" && _vm.subTab === "multi-channel"
        ? _c("multi-channel-shipping")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91d3b27e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91d3b27e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseSc/TabContent.vue
// module id = null
// module chunks = 